import { createContext, useContext } from 'react';

import DateString from '@models/DateString';
import { useDateRangeSelectionModel } from '@components/date-range-picker/useDateRangeSelectionModel';

interface DateRangePickerContext
  extends ReturnType<typeof useDateRangeSelectionModel> {
  minDate?: DateString;
  maxDate?: DateString;
}

/**
 * Context to store the details of the current DateRangePicker,
 * so we don't have to pass these props through many layers.
 */
const DateRangePickerContext = createContext<DateRangePickerContext>({
  customStartDate: {
    isValid: false,
  },
  customEndDate: {
    isValid: false,
  },
  dateClicked: () => undefined,
  dateHovered: () => undefined,
  dateUnhovered: () => undefined,
  customStartDateInputChanged: () => undefined,
  customEndDateInputChanged: () => undefined,
  swapToCustomRange: () => undefined,
  setRange: () => undefined,
});

export const DateRangePickerContextProvider = DateRangePickerContext.Provider;

/**
 * Get a reference to the current DateRangePicker context, if available.
 */
export const useDateRangePickerContext = () => {
  return useContext(DateRangePickerContext);
};
